export enum ViewLayout {
    List = "list",
    Boxes = "boxes"
}